export default function locationAsText({
    location = '',
    locationLink = '',
}): string {
    return location && locationLink
        ? `${location}: ${locationLink}`
        : location || locationLink || ''
}
